






























































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class changeMailModal extends Vue {
    @Prop() private mail! : string;
    @Prop() private isError! : boolean;
    @Prop() private errorMessages! : Array<{index : number, message: string}>;

    title = "メールアドレス変更";

    newMail = "";

    private mounted(){
        (this.$refs.mail as HTMLElement).focus();
    }

    private onDoCommand(command: string, param: any){
        this.$emit("doCommand", command, param);
    }

    private cansel(){
        this.onDoCommand("cansel", null);
    }

    private save(){
        this.onDoCommand("saveMail", this.newMail);
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
    private get userConfigUnderLineColor(){
        var style = {
            borderBottom: "solid 1px " + this.userConfigColor
        };
        return style;
    }
}
